import React from 'react';

const Footer = () => {
  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      const headerHeight = 100;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/logo-alphatech.png" alt="Alpha Tech Logo" />
            <p>Transformando ideias em realidade através de tecnologia inovadora.</p>
          </div>
          <div className="footer-links">
            <h4>Links Rápidos</h4>
            <a href="#home" onClick={(e) => handleSmoothScroll(e, '#home')}>Home</a>
            <a href="#about" onClick={(e) => handleSmoothScroll(e, '#about')}>Sobre</a>
            <a href="#services" onClick={(e) => handleSmoothScroll(e, '#services')}>Serviços</a>
            <a href="#projects" onClick={(e) => handleSmoothScroll(e, '#projects')}>Projetos</a>
          </div>
          <div className="footer-contact">
            <h4>Contato</h4>
            <p>+55 (98) 98776-0897</p>
            <p>contato@alphatechai.com.br</p>
            <div className="footer-social">
              <a
                href="https://www.instagram.com/ia.alphatech?igsh=c3U0ZnoydWZqYnly&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M16 11.37C16.1234 12.2022 15.9813 13.0522 15.5938 13.799C15.2063 14.5458 14.5932 15.1514 13.8416 15.5297C13.0901 15.9079 12.2385 16.0396 11.4078 15.9059C10.5771 15.7723 9.80976 15.3801 9.21484 14.7852C8.61991 14.1902 8.22768 13.4229 8.09402 12.5922C7.96036 11.7615 8.09202 10.9099 8.47029 10.1584C8.84856 9.40685 9.45419 8.79374 10.201 8.40624C10.9478 8.01874 11.7978 7.87659 12.63 8H13.57C14.4608 8.12532 15.3036 8.53146 15.9766 9.16453C16.6497 9.7976 17.1211 10.6259 17.32 11.53C17.3833 11.8408 17.3833 12.1592 17.32 12.47C17.1211 13.3741 16.6497 14.2024 15.9766 14.8355C15.3036 15.4685 14.4608 15.8747 13.57 16H12.63C11.7978 16.1234 10.9478 15.9813 10.201 15.5938C9.45419 15.2063 8.84856 14.5932 8.47029 13.8416C8.09202 13.0901 7.96036 12.2385 8.09402 11.4078C8.22768 10.5771 8.61991 9.80976 9.21484 9.21484C9.80976 8.61991 10.5771 8.22768 11.4078 8.09402C12.2385 7.96036 13.0901 8.09202 13.8416 8.47029C14.5932 8.84856 15.2063 9.45419 15.5938 10.201C15.9813 10.9478 16.1234 11.7978 16 12.63V11.37Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/alphatech"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M6 9H2V21H6V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <a
                href="https://linktr.ee/alphatech"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Linktree"
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Alpha Tech. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

